import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  Renderer2,
  SimpleChanges
} from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import {
  ANALYTICS_EVENTS,
  AnalyticsSiteAssets,
  ContentBodyAbodeSupportAnalytics,
  LoggingService
} from '@com-delta-idp/mnx-utils';
import { Subject, Subscription, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataLayer } from '../../common/datalayer/datalayer';
import { ApplicationConfig } from '../../config/config';
import { SwitchingAccountService } from '../../header/switching-account/switching-account.service';
import { ContentAccessibilityPopup } from '../../model/content/contentAccessibilityPopup.model';
import { ContentDarkSite } from '../../model/content/contentDarkSite.model';
import { PERequest } from '../../model/userdata-model';
import { AccountSummaryService } from '../../services/accountsummary/account-summary.service';
import { ClosestAirPortcode } from '../../services/closestairportcode.service';
import { CommonService } from '../../services/common.service';
import { ContentBodyService } from '../../services/content/contentbody.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { FlyoutExternalSiteService } from '../../services/flyout-externalsite-service/flyout-externalsite.service';
import { CookieHelper } from '../cookie-helper';
import { ContentBodyClickEventAnalyticsUtils } from './content-body-analytics-utils';

declare let delta: any;
declare let picturefillBackground: any;
declare let makeMboxVisible: any;

@Component({
  selector: 'ngc-content-body',
  templateUrl: 'content-body.html'
})
/**
 * This is the fragment which contains the Content Body from the Homepage Fragment
 */
export class ContentBodyComponent
  implements OnInit, AfterViewChecked, OnDestroy, OnChanges
{
  contentFragment: string;
  axPopupContent: ContentAccessibilityPopup;
  frag: DocumentFragment;
  peRequest: PERequest;
  public darkSiteThemeContent: ContentDarkSite;
  isEnabled = 'true';
  isDarkSiteEnabled = true;
  displayBody = true;
  contentServiceHeaderFooterSubscribe: Subscription;
  svcLoadHtmlFragmentSubcription: Subscription;
  contentLoaded = false;
  headerText: string;
  public timeouts = [];
  public multicampainId = [];
  corpName: string;
  public businessAccountIndex = 0;
  private unsubscribe: Subject<void> = new Subject();
  @Input() reRender = false;

  @Output() bodySkeleton = new EventEmitter<boolean>(true);

  constructor(
    private svc: ContentBodyService,
    private closetAirportSvc: ClosestAirPortcode,
    private acctSummarySvr: AccountSummaryService,
    private commonSvc: CommonService,
    private _config: ApplicationConfig,
    public switchingAccountService: SwitchingAccountService,
    private contentService: ContentHeaderFooterService,
    private cdf: ChangeDetectorRef,
    private elementRef: ElementRef,
    private cookieHelper: CookieHelper,
    private datalayer: DataLayer,
    private rend: Renderer2,
    private flyoutExternalSiteService: FlyoutExternalSiteService,
    private userSession: UserSessionService,
    private contentBodyClickEventAnalyticsUtils: ContentBodyClickEventAnalyticsUtils,
    private contentBodyAbodeSupportAnalytics: ContentBodyAbodeSupportAnalytics,
    @Inject(PLATFORM_ID) private platformId: Object,
    private loggingService: LoggingService
  ) {
    this.contentFragment = '';
  }

  ngOnInit(): void {
    if (this._config.onBrowser) {
      this.getPE();
      // this.peRequest = new PERequest();
      // this.svcLoadHtmlFragmentSubcription = this.svc.loadHtmlFragment()
      //   .takeUntil(this.unsubscribe)
      //   .subscribe((res) => {
      //     this.contentFragment = res;
      //     this.contentLoaded = true;
      //     try {
      //       this.getPEContent(res);
      //     } catch (err) {
      //      this.loggingService.log('Caught Error: ' + err);
      //     }
      //   }, err => {
      //     this.loggingService.log('Caught Error: ' + err);
      //   });
      // if (this.contentService.contentHeaderFooter) {
      //   this.contentServiceHeaderFooterSubscribe = this.contentService.contentHeaderFooter
      //     .takeUntil(this.unsubscribe)
      //     .subscribe(data => {
      //       if (data) {
      //         if (data.darkSite) {
      //           this.darkSiteThemeContent = data.darkSite;
      //           if (this.darkSiteThemeContent.isEnabled === this.isEnabled) {
      //             this.contentFragment = null;
      //             if (this.darkSiteThemeContent.level === this._config.get('APP_DARKSITE_LEVEL_0')) {
      //               this.isDarkSiteEnabled = false;
      //             } else {
      //               this.isDarkSiteEnabled = true;
      //             }
      //           }
      //         }
      //       }
      //     }, err => {
      //       this.loggingService.log('Caught Error: ' + err);
      //     });
      // }
      this.switchingAccountService.displayBody.subscribe((displayBody) => {
        this.displayBody = !displayBody;
        if (this.displayBody) {
          this.getPE();
        }
      });
    }
  }

  open(hrefUrl) {
    this.flyoutExternalSiteService.openFlyoutExtSiteModal(
      hrefUrl,
      this.elementRef,
      this.rend
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId)) {
      this.listenToEvents();
    }
  }

  listenToEvents() {
    // TODO: needs to refactor code - B-664953
    if (isPlatformBrowser(this.platformId)) {
      document.addEventListener('service-worker-token', () => this.getPE());
    }
  }

  getPE() {
    this.peRequest = new PERequest();
    this.svcLoadHtmlFragmentSubcription = this.svc
      .loadHtmlFragment()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (res) => {
          this.contentFragment = res;
          this.contentLoaded = true;
          try {
            if (
              this._config.get('APP_HERO_PECALL') &&
              this._config.get('APP_HERO_PECALL') === 'true'
            ) {
              this.getPEContent(res); // removed timout dcore590 and corpname handled in cookie
            } else {
              setTimeout(() => {
                // added timer to make it wait until the businessInfo gets initialized
                this.getPEContent(res);
              }, 2000);
            }
          } catch (err) {
            this.loggingService.log('Caught Error: ' + err);
          }
          /* KEY-225 - Fire Custom Events for Hero Content*/
          if (this.contentLoaded) {
            /* dcore124 */
            this.customEvent_HeroContent();
          }
        },
        (err) => {
          this.loggingService.log('Caught Error: ' + err);
        }
      );
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            this.contentServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    if (data) {
                      this.axPopupContent = data.accessibilityPopup;
                      this.headerText = data.axBrandName;
                      this.commonSvc.setAxPopupContent(this.axPopupContent);
                      if (data.darkSite) {
                        this.darkSiteThemeContent = data.darkSite;
                        if (
                          this.darkSiteThemeContent.isEnabled === this.isEnabled
                        ) {
                          this.contentFragment = null;
                          if (
                            this.darkSiteThemeContent.level ===
                            this._config.get('APP_DARKSITE_LEVEL_0')
                          ) {
                            this.isDarkSiteEnabled = false;
                          } else {
                            this.isDarkSiteEnabled = true;
                          }
                        }
                      }
                      this.cdf.detectChanges();
                    }
                  },
                  (err) => {
                    this.loggingService.log('Caught Error: ' + err);
                  }
                );
          }
        }
      });
  }

  getPEContent(res: any) {
    if (res && this._config.onBrowser && document) {
      this.frag = document.createRange().createContextualFragment(res);
      const perReqs = this.frag.querySelectorAll('.personalizationcontent');
      if (perReqs && perReqs.length > 0) {
        if (this.userSession.getServiceWorkerCheck()) {
          this.getPEContentHelper(perReqs);
        }
      }
    }
  }

  getPEContentHelper(perReqs: NodeListOf<Element>) {
    const geoLocation = this.closetAirportSvc.getClosestDeltaAirportCode();
    const custDashBrd = this.acctSummarySvr.getAccountSummaryDetails();
    forkJoin([geoLocation, custDashBrd]).subscribe(
      (results) => {
        this.peRequest.populateUserData(results[0]);
        this.peRequest.populateUserData(results[1]);
        window['targetDataElement'] = window['targetDataElement']
          ? window['targetDataElement']
          : {};
        window['targetDataElement'].profile = window['targetDataElement']
          .profile
          ? window['targetDataElement'].profile
          : {};

        const getPrefCookie = this.cookieHelper.getCookies('prefUI');
        if (getPrefCookie && getPrefCookie !== '') {
          let prefCookie = getPrefCookie.split('=');
          prefCookie = prefCookie[1].split('-');
          window['targetDataElement'].profile.mp_country = prefCookie[1];
          window['targetDataElement'].profile.mp_lang = prefCookie[0];
          const getCountryAndLanguage = {
            v39: prefCookie[0],
            v40: prefCookie[1]
          };
          this.peRequest.populateUserData(getCountryAndLanguage);
        } else {
          window['targetDataElement'].profile = {
            mp_country: 'us',
            mp_lang: 'en'
          };
        }
        const businessUserInfo = this.switchingAccountService.getUserInfo();
        const accountCookie = this.cookieHelper.getCookieValue('account');
        const corpCookie = Object.assign(
          {},
          { hasCookie: this.cookieHelper.getCookies('corp') ? true : false }
        );
        let fromIntranetLink = false;
        if (accountCookie && accountCookie.length) {
          const parseAccount = JSON.parse(accountCookie);
          const businessAccountOptionsList =
            parseAccount['businessAccountOptionsList'];
          this.businessAccountIndex = businessAccountOptionsList['accountIndex']
            ? parseInt(businessAccountOptionsList['accountIndex'])
            : 0;
        } else if (corpCookie.hasCookie) {
          fromIntranetLink = true;
        }
        const dashBrdData = results[1];
        if (dashBrdData) {
          const types: string[] = dashBrdData.crprtAgrmntTypeCode
            ? dashBrdData.crprtAgrmntTypeCode.split('|')
            : null;
          const contractMgtEnt: string[] = dashBrdData.contractMgtEnt
            ? dashBrdData.contractMgtEnt.split('|')
            : null;
          const program: string[] = dashBrdData.program
            ? dashBrdData.program.split('|')
            : null;
          const id: string[] = dashBrdData.crprtAgrmntId
            ? dashBrdData.crprtAgrmntId.split('|')
            : null;
          if (fromIntranetLink) {
            this.switchingAccountService.setAdditionalBusinessUserInfo(
              null,
              null,
              null,
              null
            );
          } else if (types && contractMgtEnt && program) {
            this.switchingAccountService.setAdditionalBusinessUserInfo(
              types[this.businessAccountIndex],
              contractMgtEnt[this.businessAccountIndex],
              program[this.businessAccountIndex],
              id[this.businessAccountIndex]
            );
          }
        }
        const additionalBusinessInfo =
          this.switchingAccountService.getAdditionalBusinessUserInfo();
        this.peRequest.populateUserData(businessUserInfo);
        this.peRequest.populateUserData(additionalBusinessInfo);
        for (let i = 0; i < perReqs.length; i++) {
          if (perReqs[i] && perReqs[i].id && perReqs[i].id !== undefined) {
            const campainId = perReqs[i].id;
            this.multicampainId.push(campainId); // multiple PE call endpoint to have request with campId as array in single call
          }
        }
        this.peRequest.populateRequestParam(this.multicampainId, 'html'); // multiplePE call
        this.svc
          .loadPEDataWithHtmlRes(this.peRequest)
          .subscribe((response: any) => {
            try {
              if (response && !response.includes('error')) {
                const doc = new DOMParser().parseFromString(
                  response,
                  'text/html'
                );
                for (let i = 0; i < perReqs.length; i++) {
                  const personalizeDiv = document.getElementById(perReqs[i].id);
                  let respCampId;
                  if (perReqs[i].id.indexOf(':') >= 0) {
                    const arr = perReqs[i].id.split(':');
                    respCampId = arr[0] + '\\:' + arr[1];
                  }
                  const persResp = doc.querySelector(
                    '#' + respCampId
                  ).innerHTML;
                  setTimeout(async () => {
                    const contentDiv = document.getElementById(perReqs[i].id);
                    const cardDivs = [
                      {
                        element: contentDiv?.querySelector(
                          '.d-flex.hero-home-text-container.flex-column'
                        ),
                        type: ANALYTICS_EVENTS.HERO_CLICK
                      },
                      {
                        element: contentDiv?.querySelector('.cardcd.parbase'),
                        type: ANALYTICS_EVENTS.TILE_CLICK
                      },
                      ...Array.from(
                        contentDiv?.querySelectorAll(
                          '.cardb.parbase.container'
                        ) || []
                      ).map((el) => ({
                        element: el,
                        type: ANALYTICS_EVENTS.BANNER_CLICK
                      }))
                    ];
                    let site_assets: AnalyticsSiteAssets[] = [];

                    await Promise.all(
                      cardDivs.map(async (item) => {
                        if (item.element) {
                          await Promise.all([
                            this.contentBodyAbodeSupportAnalytics.setHomePageClickEventAnalytics(
                              item.element,
                              item.type
                            ),
                            (async () => {
                              const assets =
                                await this.contentBodyAbodeSupportAnalytics.setHomePageSiteAssetsAnalytics(
                                  item.element,
                                  item.type
                                );
                              if (assets) {
                                site_assets = [...site_assets, ...assets];
                              }
                            })()
                          ]);
                        }
                      })
                    );
                    await this.contentBodyClickEventAnalyticsUtils.setHomePageLoadAssetAnalytics(
                      site_assets
                    );
                  }, 0);
                  if (personalizeDiv) {
                    if (
                      personalizeDiv.innerHTML.includes(
                        'bussiness-alert-banner'
                      )
                    ) {
                      personalizeDiv.innerHTML += this.updateResponse(
                        persResp,
                        perReqs[i].id
                      );
                    } else {
                      personalizeDiv.innerHTML = this.updateResponse(
                        persResp,
                        perReqs[i].id
                      );
                    }
                    this.contentLoaded = true;
                  }
                }
              }
            } catch (err) {
              this.loggingService.log('Caught Error: ' + err);
            }
            this.bodySkeleton.emit(false);
          });
      },
      (err) => {
        // this.loggingService.log('Caught Error: ' + err);
      }
    );
  }

  picturefillBackground(): void {
    if (typeof picturefillBackground === 'function') {
      picturefillBackground();
    }
  }

  ngAfterViewChecked(): void {
    const handle: ContentBodyComponent = this;
    if (this.contentLoaded) {
      try {
        handle.picturefillBackground();
        this.timeouts.push(
          setTimeout(() => {
            makeMboxVisible();
            handle.picturefillBackground();
          }, 1000)
        );
      } catch (error) {
        this.loggingService.log('Caught Error: ' + error);
      }
      this.contentLoaded = false;
    }
  }

  updateResponse(response, campaignId) {
    if (this.peRequest?.userdata?.firstName) {
      response = response.replace(
        '{{FNAME}}',
        this.peRequest.userdata.firstName
      );
    }
    if (this._config.get('APP_HERO_PECALL')) {
      const accountCookie = this.cookieHelper.getCookieValue('account');
      if (accountCookie?.length) {
        const parseAccount = JSON.parse(accountCookie);
        this.corpName = parseAccount['name'];
        this.cdf.detectChanges();
      } else {
        // if from intranetlink
        const cookieIntranet = Object.assign(
          {},
          { hasCookie: this.cookieHelper.getCookies('corp') }
        );
        if (cookieIntranet?.hasCookie?.split('|')?.length > 1) {
          this.corpName = this.cookieHelper
            .getCookies('corp')
            .split('|')[1]
            .split('=')[1]
            .replace(/#/g, ' ');
        }
      }
      if (this.corpName) {
        const replacingString =
          campaignId === 'homepage:banner'
            ? decodeURIComponent(this.corpName)
            : decodeURIComponent(this.corpName).toUpperCase();
        response = response.replace(/{{CONAME}}/g, replacingString);
      }
    } else {
      if (this.peRequest?.userdata?.selectedCompany) {
        const replacingString =
          campaignId === 'homepage:banner'
            ? this.peRequest.userdata.selectedCompany
            : this.peRequest.userdata.selectedCompany.toUpperCase();
        response = response.replace(/{{CONAME}}/g, replacingString);
      }
    }
    const elementNat = this.elementRef.nativeElement.querySelectorAll(
      'a[data-extlink="ext12"]'
    );
    if (elementNat.length > 0) {
      for (let i = 0; i < elementNat.length; i++) {
        this.rend.listen(elementNat[i], 'click', (event) => {
          event.preventDefault();
          if (
            elementNat[i].getAttribute('href') &&
            elementNat[i].getAttribute('href') !== null
          ) {
            this.open(elementNat[i].getAttribute('href'));
          }
          return false;
        });
      }
    }
    return response;
  }

  stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
  }

  customEvent_HeroContent() {
    try {
      if (isPlatformBrowser(this.platformId)) {
        this.elementRef.nativeElement.dispatchEvent(
          new CustomEvent('heroContentLoaded', {
            bubbles: true
          })
        );
      }
    } catch (err) {
      this.loggingService.log(
        'Caught Error in customEvent_HeroContent : ' + err
      );
    }
  }

  ngOnDestroy() {
    if (this.svcLoadHtmlFragmentSubcription) {
      this.svcLoadHtmlFragmentSubcription.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
    this.stopTimeout();
  }
}
